export const IMAGES_PATH = 'https://www.optimalprint.co.uk/s/assets/images/';

export default {
  IMAGES_PATH,
};
